export const daysOfWeek = [
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const timesOfDay = [
  "10:30am",
  "11:45am (Tues, Thurs, Fri, Sat)",
  "1:30pm",
  "3:30pm",
  "5:00pm",
];

const inquiryFormFields = [
  { name: "fullName", label: "Full Name *", type: "text", required: true },
  {
    name: "pronouns",
    label: "Pronouns *",
    type: "radio",
    required: true,
    options: [
      "She/her",
      "He/him",
      "They/them",
      "She/they",
      "He/they",
      "She/he/they",
    ],
  },
  {
    name: "phoneNumber",
    label: "Phone Number *",
    type: "tel",
    placeholder: "(000) 000-0000",
    required: true,
  },
  { name: "email", label: "Email *", type: "email", required: true },
  {
    name: "instagram",
    label: "Instagram Handle *",
    type: "text",
    required: true,
  },
  {
    name: "flashOrCustom",
    label: "Flash or Custom? *",
    type: "radio",
    required: true,
    options: ["Flash", "Custom"],
  },
  {
    name: "flashImage",
    type: "uploadcare-single",
    label: "Upload Flash Screenshot *",
    required: true,
    condition: { field: "flashOrCustom", value: "Flash" },
    description:
      "If you would like a flash piece, please include a screenshot of the flash piece *",
  },
  {
    name: "placement",
    label: "Placement *",
    type: "text",
    required: true,
    description:
      "Where on your body are you thinking of getting tattooed? If you are undecided, list all areas you are considering. Please note placement can affect pricing.",
  },
  {
    name: "tattooSize",
    label: "Tattoo Size *",
    type: "ruler",
    required: true,
  },
  {
    name: "colorOrBW",
    label: "Color or Black & White? *",
    type: "radio",
    required: true,
    options: ["Color", "Black & White"],
  },
  {
    name: "referenceImages",
    type: "uploadcare-multiple",
    label: "Reference Images * (Up to 3)",
    required: true,
    description: "Please upload at least one reference image.",
  },
  {
    name: "customDescription",
    label: "Custom Description *",
    type: "textarea",
    required: true,
    description:
      "If you are requesting a custom design please describe in detail the composition, elements and style you would like.",
  },
  {
    name: "preferredDays",
    label: "Preferred Days of the Week *",
    type: "checkbox",
    required: true,
    options: daysOfWeek,
  },
  {
    name: "preferredTimes",
    label: "Preferred Time of Day *",
    type: "checkbox",
    required: true,
    options: timesOfDay,
  },
  {
    name: "unavailableDates",
    label: "Specific Dates That Do Not Work",
    type: "text",
    description:
      "If there are any specific upcoming dates that don’t work for you please let me know!",
  },
  {
    name: "currentLocation",
    label: "Where Do You Currently Live? *",
    type: "text",
    required: true,
    description:
      "If you are traveling from out of town it’s good for me to know for scheduling",
  },
  {
    name: "budget",
    label: "Budget",
    type: "text",
    description:
      "Please note the shop minimum starts at $150 for the most simple/small tattoos. My hourly rate is $200/hour, hourly rate only applies to big projects, everything else is priced by the piece.",
  },
  {
    name: "tattooedBefore",
    label: "Have you been tattooed by me before?",
    type: "radio",
    options: ["Yes", "No"],
  },
  {
    name: "bookingForOthers",
    label: "Are you booking this appointment for multiple people?",
    type: "textarea",
    description: "If so, please list their names here:",
  },
  {
    name: "additionalQuestions",
    label: "Additional Questions/Concerns",
    type: "textarea",
  },
];

export default inquiryFormFields;
